import { TableRowProps } from "../../molecules/TableRow/TableRowAtom";
import {
  createInfoCell,
  createClickableCell,
  createCellWithChildren,
} from "../../utilities/CreateCell";
import { createRow } from "../../utilities/CreateRow";
import { isAdmin } from "../../utilities/checkUserRole";
import { cancellationCellStyles } from "./CreateLabelsTable.styles";

export const createLabelsRows = (
  data: any,
  history: any,
  handleCancellation: (entry: any) => void,
  userRole: string,
  onEdit: (entry: any) => void,
  onDelete: (entry: any) => void
) => {
  const rows: Array<TableRowProps> = [];

  const createCancellationCell = (entry: any) => {
  const isCancelled = entry.cancelled;

  return createCellWithChildren(
    <div
      onClick={() => {
        if (!isCancelled) {
          handleCancellation(entry);
        }
      }}
      style={cancellationCellStyles(isCancelled)}
      title={isCancelled ? "Already cancelled" : "Click to cancel"}
    >
      {isCancelled ? "Cancelled" : "Cancel"}
    </div>
  );
};

  void createCancellationCell;

  data.forEach((entry: any) => {
    const cells = [
      createInfoCell(entry.pickupDate || "—"), //Pickup Date
      createInfoCell(entry.trackingNumber), //Tracking Number
      createClickableCell(() => {
        const adminPrefix =
          history.location.pathname.indexOf("admin") !== -1 ? "/admin" : "";
        history.push(
          `${adminPrefix}/pharmacies/${entry.returnRequest.pharmacy.id}/returnrequests/${entry.returnRequest.id}/shipments/${entry.id}/label`,
          { trackingNumber: entry.trackingNumber }
        );
      }, "View Shipping Label"), // View Shipping Label
      createInfoCell(
        !entry.shipmentStatus || entry.shipmentStatus.includes("null")
          ? "-"
          : entry.shipmentStatus
      ),
      // createCancellationCell(entry),
    ];

    if (isAdmin(userRole) && entry.offlineUploaded) {
      cells.push(
        createClickableCell(() => onEdit(entry), "Edit"),
        createClickableCell(() => onDelete(entry), "Delete")
      );
    } else if (isAdmin(userRole)) {
      cells.push(createInfoCell(""), createInfoCell(""));
    }

    rows.push(createRow(...cells));
  });
  return rows;
};
